import React, { useEffect, useState } from "react";
import { X, Smartphone } from "lucide-react";
import { api } from "@/lib/api";
import { AppBadges } from "@/components/AppBadges";

const KEY = "sc_getapp_dismissed_v1";

/** Subtle, dismissible "get the app" strip for logged-in users. Renders nothing until Ashley
 *  has at least one live store link, and stays gone once dismissed. */
export default function GetAppBanner() {
  const [links, setLinks] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });

  useEffect(() => {
    api.get("/settings/app-links").then((r) => setLinks(r.data)).catch(() => setLinks({ apple: "", google: "" }));
  }, []);

  const close = () => { try { localStorage.setItem(KEY, "1"); } catch { /* noop */ } setDismissed(true); };

  if (dismissed || !links || (!links.apple && !links.google)) return null;

  return (
    <div data-testid="get-app-banner"
      className="relative z-40 border-b border-white/10 bg-gradient-to-r from-violet-900/40 via-slate-900/60 to-fuchsia-900/30 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 text-sm text-slate-200">
          <Smartphone className="w-4 h-4 text-violet-300 shrink-0" />
          <span className="font-semibold">Salesman Connect is better in the app.</span>
          <span className="hidden sm:inline text-slate-400">Jobs, C.O.R.E. & Connie in your pocket.</span>
        </div>
        <div className="flex items-center gap-3">
          <AppBadges size="sm" />
          <button onClick={close} data-testid="get-app-dismiss" aria-label="Dismiss" className="text-slate-400 hover:text-white p-1">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
